import {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {selectIsWidget} from '../../store/slices/channel/slice';

type Props = {
  children: ReactElement | ReactElement[];
};

export const Widget = ({children}: Props) => {
  const isWidget = useSelector(selectIsWidget);
  if (!isWidget) {
    return null;
  }
  return <>{children}</>;
};
